import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { SHADOW_200 } from "./overviewStyles";

type SectionCardProps = {
  label: ReactNode;
  action?: ReactNode;
  className?: string;
  labelClassName?: string;
  headerClassName?: string;
  children: ReactNode;
};

export function SectionCard({ label, action, className, labelClassName, headerClassName, children }: SectionCardProps) {
  return (
    <div
      className={cn("bg-white p-5", SHADOW_200, className)}
    >
      <div className={cn("flex items-center justify-between mb-4", headerClassName)}>
        <div
          className={cn(
            "flex items-center gap-2.5 text-[14px] leading-[22px] font-medium tracking-[-0.14px] text-innoveraZinc-900",
            labelClassName
          )}
        >
          {label}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}
